import { render, staticRenderFns } from "./brand-detail.vue?vue&type=template&id=9800708e&scoped=true&"
import script from "./brand-detail.vue?vue&type=script&lang=js&"
export * from "./brand-detail.vue?vue&type=script&lang=js&"
import style0 from "./brand-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-detail.vue?vue&type=style&index=1&id=9800708e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9800708e",
  null
  
)

export default component.exports